import { useState } from "react";
import { Mail } from "lucide-react";
import { useForm } from "react-hook-form";
import Button from "../../components/ui/Button";
import Dialog from "../../components/ui/Dialog";

interface RequestResetFormValues {
  email: string;
}

interface Props {
  defaultEmail: string;
  inputClassName: string;
  onSubmit: (values: RequestResetFormValues) => Promise<{ type: "error" | "success"; text: string }>;
  onClose: () => void;
}

export default ({ defaultEmail, inputClassName, onSubmit, onClose }: Props) => {
  const requestResetForm = useForm<RequestResetFormValues>({
    defaultValues: { email: defaultEmail },
  });
  const [notice, setNotice] = useState<{ type: "error" | "success"; text: string } | null>(null);

  const handleSubmit = requestResetForm.handleSubmit(async values => {
    const result = await onSubmit(values);
    setNotice(result);
  });

  return (
    <Dialog title="Reset password" subtitle="We will email a temporary password and secure reset link." onClose={onClose} TitleIcon={Mail}>
      <form className="space-y-4" onSubmit={event => void handleSubmit(event)}>
        {notice && (
          <div className={`rounded-xl border px-4 py-3 text-sm ${notice.type === "error" ? "border-rose-200 bg-rose-50 text-rose-700" : "border-emerald-200 bg-emerald-50 text-emerald-700"}`}>
            {notice.text}
          </div>
        )}
        <div className="space-y-2">
          <label className="text-sm font-medium text-slate-700" htmlFor="request-reset-email">Email</label>
          <input
            id="request-reset-email"
            type="email"
            autoComplete="email"
            className={inputClassName}
            {...requestResetForm.register("email", { required: true })}
          />
        </div>
        <div className="flex justify-end gap-3">
          <Button type="button" variant="ghost" onClick={onClose}>Cancel</Button>
          <Button type="submit" disabled={requestResetForm.formState.isSubmitting}>
            {requestResetForm.formState.isSubmitting ? "Sending..." : "Send reset email"}
          </Button>
        </div>
      </form>
    </Dialog>
  );
};
